import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = e((r, t) => /* @__PURE__ */ o.jsx(
  a,
  {
    ref: t,
    ...r,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M4.25 1A4.25 4.25 0 0 0 0 5.25C0 10.5 7.5 14 8 14s8-3.5 8-8.75a4.25 4.25 0 0 0-8-2.002A4.25 4.25 0 0 0 4.25 1"
          }
        )
      }
    )
  }
));
i.displayName = "HeartIcon";
export {
  i as HeartIcon,
  i as default
};
//# sourceMappingURL=index.js.map
